module.exports = __webpack_public_path__ + "media/images/follow us-99682b26fce9249e5135df24c339d01f.png";